export default "__VITE_ASSET__D5_a_QL4__"